<template>
  <div class="medium-modal modal">

    <div class="modal-main">

      <p class="modal-body">
        <span>投稿された画像は二次利用される場合があります。それでもよろしいですか？</span>
      </p>

      <button class="btn">投稿する</button>
    </div>

  </div>
</template>

<script>
import utils from '../../../utils/vue/Utils'
import VueCookies from 'vue-cookies'
import Vue from 'vue'

Vue.use(VueCookies)
export default {
  name: 'photo-confirm-modal',
  mixins: [utils]
}
</script>

<style lang="scss" scoped src="../scss/PhotoConfirmModal.scss"></style>



// WEBPACK FOOTER //
// src/components/modal/vue/PhotoConfirmModal.vue